import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import menuItems from './menuItems.json';
import externalLinks from './externalLinks.json';

export default function SectorMenu() {
    const [ showSector, setShowSector ] = useState({});
    const [ selectedTab, setSelectedTab ] = useState();
    const [ searchParams ] = useSearchParams();
    const navigate = useNavigate();

    const toggleShowSector = (sector) => {
        // Previous code: Expand selected sector
        //setShowSector({...showSector, [sector]:!showSector[sector]});
        // Changed to close all other sector menus and expand the selected one
        setShowSector((prevState) => (
            {[sector]: !prevState[sector]}
        ));
    };

   const linkClick = (linkTab) => {
      // Anchor link opened url. Need to navigate to the requested route.
      navigate(linkTab);
    };

    useEffect(() => {
      // Changes highlighting of selected tab when search params change
      const product = searchParams.get("product");
      setSelectedTab(product);
    }, [searchParams]);
    
    return (
        <>
            {menuItems.map((item, index) => (
                item.tabs.length > 0 && (
                    <Box key={index} sx={{border: "0.5px solid #AFE1AF", pb:1}}>
                        <Button variant="text" size="large" value={item.value} onClick={()=>toggleShowSector(item.value)}>{item.title}</Button>
                        <IconButton
                            color="primary"
                            value={item.value} 
                            onClick={()=>toggleShowSector(item.value)}
                            edge="start" 
                            tabIndex={-1}
                        >
                            {showSector[item.value] ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                        </IconButton>
                        {showSector[item.value] &&
                            <>
                                {item.tabs.map((tabitem, tabindex) => (
                                    <React.Fragment key={tabindex}>
                                        <br />
                                        <Tooltip title={tabitem.tooltip || ""} placement="right" sx={{ zIndex: 1500 }}>  
                                            <>
                                            { !tabitem.submenus && !tabitem.externalLink &&
                                                <Link 
                                                    component={RouterLink}
                                                    to={"?product=" + tabitem.linkTo} 
                                                    underline="hover"
                                                    tabIndex={0}
                                                    sx={{ pl: 2 }}
                                                >
                                                    <Typography 
                                                        component="span"
                                                        variant="body"
                                                        sx={{ fontFamily: "Arial Narrow, Arial, sans-serif", fontWeight: tabitem.linkTo===selectedTab ? "bold" : "regular" }}
                                                    >
                                                        {tabitem.label}
                                                    </Typography>
                                                </Link>
                                            }
                                            { !tabitem.submenus && tabitem.externalLink &&
                                                <Link 
                                                    component="a"
                                                    href={externalLinks[tabitem.linkTo]}
                                                    target="_blank"
                                                    rel="noopener noreferer"
                                                    underline="hover"
                                                    tabIndex={0}
                                                    sx={{ pl: 2 }}
                                                >
                                                    <Typography 
                                                        component="span"
                                                        variant="body"
                                                        onClick={()=>{linkClick("?product=" + tabitem.linkTo)}}
                                                        sx={{ fontFamily: "Arial Narrow, Arial, sans-serif", fontWeight: tabitem.linkTo===selectedTab ? "bold" : "regular" }}
                                                    >
                                                        {tabitem.label}
                                                    </Typography>
                                                </Link>
                                            }
                                            { tabitem.submenus &&
                                                <Typography 
                                                    component="span"
                                                    variant="body"
                                                    sx={{ fontFamily: "Arial Narrow, Arial, sans-serif", pl: 2 }}
                                                >
                                                    {tabitem.label}:
                                                </Typography>
                                            }
                                            </>
                                        </Tooltip>
                                        {/* --- SUBMENUS --- */}
                                        {tabitem.submenus && tabitem.submenus.map((subitem, subindex) => (
                                            <React.Fragment key={subindex}>
                                                <br />
                                                <Tooltip title={subitem.tooltip || ""} placement="right" sx={{ zIndex: 1500 }}>
                                                    {!subitem.externalLink ? (
                                                        <Link
                                                            component={RouterLink}
                                                            to={"?product=" + subitem.linkTo}
                                                            underline="hover"
                                                            tabIndex={0}
                                                            sx={{ pl: 4}}
                                                        >
                                                            <Typography
                                                                component="span"
                                                                variant="body"
                                                                sx={{ 
                                                                    fontFamily: "Arial Narrow, Arial, sans-serif", 
                                                                    fontWeight: subitem.linkTo === selectedTab ? "bold" : "regular" 
                                                                }}
                                                            >
                                                                {subitem.label}
                                                            </Typography>
                                                        </Link>
                                                    ) : (
                                                        <Link
                                                            component="a"
                                                            href={externalLinks[subitem.linkTo]}
                                                            target="_blank"
                                                            rel="noopener noreferer"
                                                            underline="hover"
                                                            tabIndex={0}
                                                            sx={{ pl: 4 }} 
                                                        >
                                                            <Typography
                                                                component="span"
                                                                variant="body"
                                                                onClick={() => { linkClick("?product=" + subitem.linkTo) }}
                                                                sx={{ 
                                                                    fontFamily: "Arial Narrow, Arial, sans-serif", 
                                                                    fontWeight: subitem.linkTo === selectedTab ? "bold" : "regular" 
                                                                }}
                                                            >
                                                                {subitem.label}
                                                            </Typography>
                                                        </Link>
                                                    )}
                                                </Tooltip>
                                            </React.Fragment>
                                        ))}
                                        {/* --- END SUBMENUS --- */}
                                    </React.Fragment>
                                ))}
                            </>
                        }
                    </Box>
                )
            ))}
        </>
    );
}
